// extracted by mini-css-extract-plugin
export default {"parentClientContainer":"ParentClient_parentClientContainer__-U+Mo"};